var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 0L1.60718 6V18L11.9995 24L22.3918 18V6L11.9995 0Z",
    fill: "#82D2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 12V0L1.60718 6L11.9995 12Z",
    fill: "#08B7FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60718 6V18L11.9995 12L1.60718 6Z",
    fill: "#006DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3923 6L12 12L22.3923 18V6Z",
    fill: "#08B7FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 12L1.60718 18L11.9995 24V12Z",
    fill: "#0050C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24L22.3923 18L12 12V24Z",
    fill: "#006DFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.865 15.3863V8.61399L11.9999 5.22778L6.13489 8.61399V15.3863L11.9999 18.7725L17.865 15.3863Z",
    fill: "#82D2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.865 15.3863V8.61399L12 5.22778V18.7725L17.865 15.3863Z",
    fill: "#55CBFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGems);
export default __webpack_public_path__ + "static/media/gems.e5513f486e936a001f97787ee72d2618.svg";
export { ForwardRef as ReactComponent };